export const iconFontAwesomeChildhoodCookieBite = (
	<i className="fa-solid fa-cookie-bite"></i>
);
